import {FunnelEventName, EventProperties, TrackEventOptions} from './PostHogTypes'
import {PostHogService} from './PostHogService'
import DeduplicationStore from './DeduplicationStore'

export function trackEvent(
  eventName: FunnelEventName,
  properties: EventProperties,
  options?: TrackEventOptions
): void {
  if (!PostHogService.getInstance().isInitialized()) return
  if (!properties.user_id) return

  const dedupKey = options?.dedupKey
  if (dedupKey && DeduplicationStore.has(eventName, dedupKey)) return

  const withSource = {...properties, source_app: 'shipbae_web'}

  PostHogService.getInstance().capture(eventName, withSource as Record<string, unknown>)

  if (dedupKey) {
    DeduplicationStore.add(eventName, dedupKey)
  }
}
